import { get } from 'vio-libs';
export function getNetworkingOverview(organization) {
    return get(`networking-overview?organization=${organization}`);
}
